import React from 'react';
import Button from '@mui/material/Button';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const WhatsAppButtonLong: React.FC = () => {
    const handleClick = () => {
        const phoneNumber = "+919028249977"; // Replace with actual number
        const url = `https://api.whatsapp.com/send/?phone=${phoneNumber}&text=Hi&type=phone_number&app_absent=0`;
        window.open(url, '_blank');
    };

    return (
        <>
            <Button
                variant="contained"
                color="primary"                
                startIcon={<WhatsAppIcon />}
                onClick={handleClick}
                sx={{           
                    color: 'white',              // Text color
                    background: 'linear-gradient(45deg,rgb(5, 211, 15) 30%,rgb(85, 184, 79) 90%)',
                    '&:hover': {
                        backgroundColor: '#1ebe57', // Darker green on hover
                    },
                    textTransform: "none",
                    padding: "7px 14px",
                    fontSize: "16px",
                    WebkitTextFillColor: 'white',
                }}
            > Chat with Our Smart Assistant!
            </Button>
        </>
    );
};

export default WhatsAppButtonLong;
